import PropTypes from 'prop-types';
import React from 'react';
import IconButton from 'material-ui/IconButton';
import Close from 'material-ui/svg-icons/navigation/close';
import { grey700 } from 'material-ui/styles/colors';

const CloseModalButton = props => {
  const { white, ...otherProps } = props;
  return (
    <IconButton
      {...otherProps}
    >
      <Close color={!white ? grey700 : '#fff'}/>
    </IconButton>
  );
};

CloseModalButton.propsTypes = {
  white: PropTypes.bool,
};

CloseModalButton.defaultProps = {
  white: false
};

export default CloseModalButton;